import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';

import {
  iCompanyRequest,
  iCompanyResult,
} from 'src/app/helpers/Interfaces/company';
import {
  iPaginationRequest,
  iPaginationResult,
} from 'src/app/helpers/Interfaces/pagination';
import { environment } from 'src/environments/environment.development';

@Injectable({
  providedIn: 'root',
})
export class CompanyService {
  private readonly _getAll = `${environment.base_url}/api/Company/GetAll`;
  private readonly _getAllWithRelationShip = `${environment.base_url}/api/Company/GetAllWithRelationShip`;
  private readonly _getAllPaginated = `${environment.base_url}/api/Company/GetAllNew`;
  private readonly _add = `${environment.base_url}/api/Company/Add`;
  private readonly _update = `${environment.base_url}/api/Company/Update`;
  private readonly _remove = `${environment.base_url}/api/Company/Remove`;

  constructor(private _http: HttpClient) { }

  private _shapePayload(payload: iCompanyRequest) {
    const req = new FormData();
    if (payload.id) req.append('Id', payload.id);
    if (payload.cityId) req.append('CityId', payload.cityId);
    if (payload.name) req.append('Name', payload.name);
    if (payload.phone) req.append('Phone', payload.phone);
    if (payload.email) req.append('Email', payload.email);
    if (payload.address) req.append('Address', payload.address);
    if (payload.file) req.append('File', payload.file);
    if (payload.slogan) req.append('Slogan', payload.slogan);
    if (payload.details) req.append('Details', payload.details);
    if (payload.workspaceId) req.append('Details', payload.workspaceId);
    return req;
  }
  private _processResponse(res: iCompanyResult): iCompanyResult {
    return {
      ...res,
      logo: res.logo
        ? `${environment.base_url}/${res.logo}`
        : '/assets/images/no-image.png',
    };
  }

  getAll(workspaceId?: string, alt: boolean = false) {
    let headers = new HttpHeaders();
    if (workspaceId) {
      headers = headers.set('WorkspaceId', workspaceId);
    }
    if (alt) {
      headers = headers.set('CompanyId', environment.emptyGuid);
      headers = headers.set('StationId', environment.emptyGuid);
    }
    return this._http
      .get<iCompanyResult[]>(this._getAll, {
        responseType: 'json',
        headers: headers,
      })
      .pipe(map((res) => res.map(this._processResponse)));
  }

  add(payload: iCompanyRequest) {
    const req = this._shapePayload(payload);
    return this._http
      .post<iCompanyResult>(this._add, req, {
        responseType: 'json',
      })
      .pipe(map(this._processResponse));
  }
  update(payload: iCompanyRequest) {
    const req = this._shapePayload(payload);
    return this._http
      .put<iCompanyResult>(this._update, req, {
        responseType: 'json',
      })
      .pipe(map(this._processResponse));
  }
  remove(id: string) {
    return this._http.delete(`${this._remove}?id=${id}`, {
      responseType: 'json',
    });
  }
  getAllWithRelationShip(payload: iPaginationRequest) {
    return this._http.post<iPaginationResult<iCompanyResult>>(
      `${this._getAllWithRelationShip}`,
      payload,
      {
        responseType: 'json',
      }
    );
  }
  getAllPaginated(payload: iPaginationRequest) {
    return this._http.post<iPaginationResult<iCompanyResult>>(
      `${this._getAllPaginated}`, payload,
      {
        responseType: 'json',
      }
    );
  }
}
